import Carousel from "./components/Carousel";

let tesimonialsCarousel = new Carousel(".Testimonials .carousel")

let intersections = new Map()
let intersectionChanged = function (entry) {
  if (entry.isIntersecting && intersections.get(entry.target) != null) {
    clearInterval(intersections.get(entry.target))

    intersections.set(entry.target, setInterval(() => {
        // in viewport
        tesimonialsCarousel.scrollToNextPage()
      }, 8000))
  } else if (entry.isIntersecting) {
    intersections.set(entry.target, setInterval(() => {
        // in viewport
        tesimonialsCarousel.scrollToNextPage()
      }, 8000))
  } else if (!entry.isIntersecting && intersections.get(entry.target) != null) {
    // not in viewport
    clearInterval(intersections.get(entry.target))
  }
}

let callback = (entries, observer) => {
  entries.forEach(intersectionChanged)
}

let options = {
  threshold: 0.1
}

let observer = new IntersectionObserver(callback, options)
observer.observe(tesimonialsCarousel.carousel)


document.querySelectorAll(".ResultCard-popover").forEach(el => {
    let trigger = el
    let popover = new Popover(trigger, { position: "right" })

    trigger.addEventListener("mouseover", () => {
        popover.toggle()
    })
})
